import { Component, Input, OnInit } from '@angular/core';
import { SeminarCardModel } from '../../../../models/seminar-card.model';
import { getUserFullName, getUserInitials } from '../../../../utils/user.utils';

@Component({
  selector: 'app-seminar-card-element',
  templateUrl: './seminar-card-element.component.html',
  styleUrl: './seminar-card-element.component.scss',
  standalone: false,
})
export class SeminarCardElementComponent implements OnInit {
  @Input() seminarCard: SeminarCardModel;

  public getFullName = getUserFullName;

  public ngOnInit() {
    if (this.seminarCard === undefined) {
      const lecturer = {
        id: null,
        firstname: 'Marta',
        lastname: 'Musterfrau',
        email: 'mm@example.com',
      };
      this.seminarCard = {
        seminarId: null,
        seminarDateSeriesId: null,
        title: 'Placeholder Title',
        lecturer: lecturer,
        lecturerInitials: getUserInitials(lecturer),
        date: new Date(),
        image: 'Placeholder Location',
        isCanceled: false,
      };
    }
  }
}
